import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import useLocalStorage from "hooks/useLocalStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedInUser, setLoggedInUser] = useLocalStorage("login_user", null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!loggedInUser);

  const loginUser = useCallback((userData) => {
    setLoggedInUser(userData);
    setIsLoggedIn(true);
  }, []);

  const logoutUser = useCallback(() => {
    setLoggedInUser(null);
    setIsLoggedIn(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      loggedInUser,
      isLoggedIn,
      loginUser,
      logoutUser,
    }),
    [isLoggedIn]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
